<template>
    <div class="subPage">
        <br />
        <div class="model filterContent">
            <!-- 头部信息栏 -->
            <FeedBackHeader :userScore="userScore" :score="score"/>
            <!-- 意见建议 -->
            <FeedBackSuggest :imgUrl="imgUrl" :changeImgUrl="changeImgUrl" :changeText="changeText"/>
            <!-- 联系方式 -->
            <FeedBackContact :changeNumber="changeNumber"/>
            <!-- 保存按钮 -->
            <div class="saveContainer">
                <mt-button class="save" @click="submit">提交</mt-button>
            </div>
            <!-- 占位盒子 -->
            <Empty />
        </div>
      <go-back-home/>
    </div>
</template>

<script>
import FeedBackHeader from '../feedBackElement/FeedBackHeader';
import FeedBackSuggest from '../feedBackElement/FeedBackSuggest';
import FeedBackContact from '../feedBackElement/FeedBackContact';
import Empty from '../comm/Empty';
import UserFetch from '../../fetch/user';
import { userWebService }  from '@/utils/webService';
const webService = userWebService;
//const webService = new UserFetch();

export default {
  name: 'FeedBack',
  meta:{page:true},
  components: {
      FeedBackHeader,
      FeedBackSuggest,
      FeedBackContact,
      Empty
  },
  data() {
    return {
        userScore: 4,
        imgUrl: '',
        text: '',
        number: '',
    }
  },
  methods: {
      score: function(value) {
          this.userScore = value;
      },
      changeImgUrl(value) {
          this.imgUrl = value;
      },
      changeText(value) {
          this.text = value.target.value;
      },
      changeNumber(e) {
          console.log(e)
          this.number = e.target.value;
      },
      submit() {
          if (this.text.trim() === '') {
              this.$store.dispatch('user/handleErrorMessage', '未填写意见与建议 请填写后再提交');
              return;
          }
          webService.feedBack({
            userScore: this.userScore,
            imgUrl: this.imgUrl,
            text: this.text,
            number: this.number,
          })
          .then(response => {
              const self = this;
              this.$store.dispatch('user/handleSuccessMessage', response.data.msg);
              setTimeout(() => {
                self.$router.push('/user/detail')
              }, 1000);
          })
          .catch(err => this.$store.dispatch('user/handleErrorMessage', err))
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.filterContent {
    height: fit-content;
}
.saveContainer {
    width: 90%;
    padding: 0 5%;
}
.save {
    width: 100%;
    background: #009688;
    color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/page/FeedBack.vue